<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="trainingTrackings">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <span class="font-bold text-dark mr-8">{{ packName }}</span> &nbsp;
        <div
          @click="loadTrainingTracking()"
          class="
            btn-add-new
            p-3
            mb-4
            mt-4
            mr-4
            rounded-lg
            cursor-pointer
            flex
            items-center
            justify-center
            text-lg
            font-medium
            text-base text-primary
            border border-solid border-primary
          "
        >
          <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Actualiser</span>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="params.search"
            @keypress.enter="loadTrainingTracking()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Formation</vs-th>
        <vs-th sort-key="user_name">Agent</vs-th>
        <vs-th sort-key="time">Temps passé</vs-th>
        <vs-th sort-key="updated_at">Dernière mise à jour</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.title }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ tr.user_name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-price">{{ formateDuration(tr.time) }}</p>
            </vs-td>
            <vs-td>{{ tr.updated_at }}</vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-row>
      <vs-col
        vs-offset="5"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      >
        <vs-pagination
          v-if="last_page && params.page"
          :total="last_page"
          v-model="params.page"
        ></vs-pagination>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { _buildQuery } from "../../../helpers/buildquery";

export default {
  name: "listPacksAdminUserTracking",
  data: () => ({
    loading: false,
    isMounted: false,
    trainingTrackings: [],
    itemsPerPage: 6,
    params: {
      page: 1,
      limit: 10,
      search: "",
      pack: "",
    },
    last_page: null,
    packName: "",
  }),
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  created() {
    this.loadTrainingTracking();
  },
  watch: {
    "params.page": function (value) {
      this.loadTrainingTracking(value);
    },
    "params.search": function (value) {
      if (value == "") {
        this.loadTrainingTracking(value);
      }
    },
  },
  methods: {
    formateDuration(totalSeconds) {
      let hours = Math.floor(totalSeconds / 3600) + "h ";
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60) + "m ";
      let seconds = (totalSeconds % 60) + "s";

      return hours + minutes + seconds;
    },
    async loadTrainingTracking() {
      try {
        this.$vs.loading();
        this.params.pack = this.$route.params.slug;
        let response = await this.$http.get(
          "/trainings-pack/time-tracking" + _buildQuery(this.params)
        );
        if (response.data) {
          this.packName = response.data.details.pack;
          this.trainingTrackings = response.data.infos.data;
          this.last_page = response.data.infos.last_page;
          this.$vs.loading.close();
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erreur",
          text: "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss"></style>
